import apiService from '../utils/apiService';

import {
  GET_ATTACHMENT,
  GET_ATTACHMENT_START,
  GET_ATTACHMENT_ERROR,
  CLEAR_ATTACHMENT,
} from './types';

import { attachmentFindPath } from '../constants/apiEndpoints';
import { createNotification } from '../utils';
import { notificationTypeError } from '../constants/globals';

const unmountAttachment = () => {
  return {
    type: CLEAR_ATTACHMENT,
  };
};

const getAttachmentStart = () => {
  return {
    type: GET_ATTACHMENT_START,
  };
};
const getAttachmentSuccessfully = (data) => {
  return {
    type: GET_ATTACHMENT,
    payload: data,
  };
};
const getAttachmentUnsuccessfully = (err) => {
  return {
    type: GET_ATTACHMENT_ERROR,
    payload: err,
  };
};

export const findAttachmentByName = (
  documentName,
  controllerReference,
  message
) => {
  return (dispatch) => {
    dispatch(getAttachmentStart());
    return apiService
      .get(attachmentFindPath(documentName, controllerReference))
      .then((response) => {
        dispatch(getAttachmentSuccessfully(response.data));
      })
      .catch((err) => {
        dispatch(getAttachmentUnsuccessfully(err?.response?.data));
        createNotification(
          notificationTypeError,
          message.filePreviewTitle,
          err?.response?.data?.message
        );
      });
  };
};

export const removeAttachment = () => {
  return (dispatch) => {
    dispatch(unmountAttachment());
  };
};
